import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate/Content';

const ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent}
    />
  );
};

ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedPostSelectionNextUpRefreshStepTemplate;
